// extracted by mini-css-extract-plugin
module.exports = {"brandDefault":"var(--app-brand-06)","brandDark":"var(--app-brand-04)"};